<template>
  <div id="navbar">

    <!-- Navigation Left -->
    <v-navigation-drawer 
      id="drawer-desktop-left"
      class="nav-desktop" 
      app 
      fixed
      left 
      dark
      width="190"
      :clipped="$vuetify.breakpoint.mdAndUp" 
      v-model="drawerLeft"
      >
      <v-toolbar flat class="logo-background">
        <v-list class="pa-0">
          <v-list-tile>
              <router-link class="" to="/dashboard" tag="span" style="cursor: pointer">
                <img class="logo-img" src="../assets/Logo_MarketPlace.png" alt="marketpalce">
              </router-link>
               <v-icon right small @click.stop="drawerLeft = !drawerLeft" class="btn-close mr-0" color="grey darken-1">close</v-icon>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list dense>
        <!-- Productivity Box -->
        <template>
          <v-list-tile class="mb-3">
            <v-list-tile-content>
              <v-container grid-list-xs fluid class="px-0" v-if="userInfo[0]">
                <v-layout row wrap align-center text-xs-center>
                  <v-flex xs6 @click="goProductivity">
                    <v-card class="card-products-active" style="box-shadow:none">
                      <div class="title card-products-active-count">365</div>
                      <div class="sub-title card-products-active-text">Active Products</div>
                    </v-card>
                  </v-flex>
                  <v-flex xs6>
                    <v-card class="card-points" style="box-shadow:none">
                      <br>
                      <div class="title card-points-count">{{ userInfo[0].points || '0' }}</div>
                      <div class="sub-title card-points-text">Points</div>
                      <br>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <!-- Main Menu -->
        <template v-for="item in items">
          <!-- child toggle -->
          <v-list-group v-if="item.children" v-model="item.model" :key="item.title">
            <!-- header title -->
            <v-list-tile slot="item" @click="">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.title }}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon>{{ item.model ? item.icon : item['icon-alt'] }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
            <!-- menu in title -->
            <v-list-tile v-for="(child, i) in item.children" :key="i" @click="" router :to="child.link">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.title }}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
          <!-- other menu -->
          <v-list-tile v-else router :to="item.link"  :key="item.title">
            <!-- <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action> -->
            <v-list-tile-content>
              <v-list-tile-title >
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        <!-- <v-divider dark class="my-0"></v-divider> -->
        
        <!-- marketplace menu -->
        <v-subheader class="grey--text text--darken-1">Marketplace</v-subheader>
        <template v-for="item in itemsMarketplace">
           <v-list-tile router :to="item.link"  :key="item.title">
            <!-- <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action> -->
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

         <!-- <v-divider dark class="my-0"></v-divider> -->
        
        <!-- Group menu -->
        <v-subheader class="grey--text text--darken-1" @mouseover="iconGroup=!iconGroup" @mouseout="iconGroup=!iconGroup">
          Group
          <v-spacer></v-spacer>
          <v-tooltip top color="black" style="cursor:pointer">
            <v-icon v-if="iconGroup == true" @click="createGroup" color="white" slot="activator" style="font-size:20px">add_circle</v-icon>
            <v-icon v-else @click="createGroup" color="grey darken-1" slot="activator" style="font-size:20px">add_circle_outline</v-icon>
            <span>สร้างกลุ่ม</span>
          </v-tooltip>
        </v-subheader>
        <template v-for="item in itemsGroup">
           <v-list-tile router :to="item.link"  :key="item.groupid">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        
        <!-- Interest Menu -->
        <template v-for="item in itemsInterest">
          <!-- child toggle -->
          <v-list-group v-if="item.children" v-model="item.model" :key="item.title">
            <!-- header title -->
            <v-list-tile slot="item" @click="">
              <v-list-tile-content>
                <v-list-tile-title class="grey--text text--darken-1">
                  {{ item.title }}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action >
                <v-icon color="grey">{{ item.model ? item.icon : item['icon-alt'] }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
            <!-- menu in title -->
            <v-card color="transparent">
              <v-card-text class="pa-1">
                <v-chip 
                  label
                  class="card-interest-chip"
                  v-for="item, index in userInterest" 
                  :key="item.typeid"
                  >
                  {{item.nametha}}
                </v-chip>
                <v-icon color="grey darken-1" class="card-interest-add" @click="addInterest = !addInterest">add_box</v-icon>
              </v-card-text>
            </v-card>
            <dialog-interest :userInterest="userInterest" v-if="addInterest == true"></dialog-interest>
          </v-list-group>
          <!-- other menu -->
          <v-list-tile v-else router :to="item.link"  :key="item.title">
            <!-- <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action> -->
            <v-list-tile-content>
              <v-list-tile-title >
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        <div v-if="$session.get('roleid') == 'ROLE000001'">

        <!-- <v-divider dark class="my-2"></v-divider> -->
        <!-- <v-subheader class="grey--text text--darken-1">
          Admin
        </v-subheader> -->
        <!-- Admin Menu -->
        <template v-for="item in itemsAdmin">
          <!-- child toggle -->
          <v-list-group v-if="item.children" v-model="item.model" :key="item.title">
            <!-- header title -->
            <v-list-tile slot="item" @click="">
              <v-list-tile-content>
                <v-list-tile-title class="grey--text text--darken-1">
                  {{ item.title }}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon color="grey">{{ item.model ? item.icon : item['icon-alt'] }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
            <!-- menu in title -->
            <v-list-tile v-for="(child, i) in item.children" :key="i" @click="" router :to="child.link">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.title }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else router :to="item.link"  :key="item.title">
            <v-list-tile-content>
              <v-list-tile-title >
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        </div>
        
      </v-list>
    </v-navigation-drawer>

    <!-- Navigation Right  -->
    <v-navigation-drawer 
      id="drawer-desktop-right"
      app 
      fixed 
      temporary 
      right 
      :clipped="$vuetify.breakpoint.mdAndUp" 
      v-model="drawerRight">
      <user-info :userInfo="userInfo"></user-info>
    </v-navigation-drawer>

    <!-- Open left bar -->
    <div id="open-left-bar" v-if="!drawerLeft">
      <v-icon medium @click.stop="drawerLeft = !drawerLeft" class="btn-close mr-0" color="grey darken-1">menu</v-icon>
    </div>
    <!-- Search Bar -->
    <div id="search-box">
      <!-- <v-container grid-list-xs>
        <v-layout row warp align-center justify-center>
          <v-flex xs12>
            <autocomplete
              ref="autocomplete"
              placeholder="ค้นหา"
              :source="states"
              input-class="search-input input-group--hide-details input-group--placeholder input-group--text-field input-group--single-line theme--light"
              @selected="(e) => this.onSubmit('selected', e)"
              @enter="(e) => this.onSubmit('enter', e)"
              >
            </autocomplete>
          </v-flex>
        </v-layout>
      </v-container> -->
    </div>
    <!-- User Info Bar -->
    <div v-if="drawerRight == false"  id="profile-box" v-for="user in userInfo" key="userid">
      <v-container v-if="showInfo" grid-list-xs>
        <v-layout row warp text-xs-right align-center justify-center>
          <v-flex xs4>
            <!-- Have Notice -->
            <v-badge key="notification-icon" v-if="countNotification > 0" overlap color="red">
              <span slot="badge">{{countNotification}}</span>
              <v-icon large color="yellow darken-2" @click.stop="goNotificationPage">notifications</v-icon>
            </v-badge>
            <!-- Dont have Notice -->
            <v-badge key="notification-icon" v-else>
              <v-icon large color="grey lighten-1" @click.stop="goNotificationPage">notifications</v-icon>
            </v-badge>
          </v-flex>
          <v-flex xs6 @click.stop="drawerRight = !drawerRight">
            <div class="subheading">
             Welcome, {{user.firstname }}
            </div>
            <div class="caption" style="font-size:9px!important;">
              {{ checkLocation }}
            </div>
          </v-flex>
          <v-flex xs2 class="text-xs-right" @click.stop="drawerRight = !drawerRight">
            <img class="picture-profile" :src="user.picture ? user.picture : '../assets/NoPicture.png'" alt="" width="40" height="40">
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <!-- Desktops Toolbar -->
    <!-- <v-toolbar
      app 
      flat 
      fixed
      dark 
      class="hidden-sm-and-down toolbar-desktop"
      :clipped-right="$vuetify.breakpoint.mdAndUp" 
      :clipped-left="$vuetify.breakpoint.mdAndUp" 
      >
      <v-toolbar-side-icon @click.stop="drawerLeft = !drawerLeft"></v-toolbar-side-icon>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <router-link class="ml-3" to="/dashboard" tag="span" style="cursor: pointer">
            <img class="logo-img" src="../assets/Logo_MarketPlace.png" alt="marketpalce">
        </router-link>
      </v-toolbar-title>
      <v-layout row align-center style="width: 600px">
        <v-select
          label="ค้นหา"
          class="white--text hidden-sm-and-down"
          autocomplete
          single-line
          hide-details
          item-text="productname"
          item-value="productname"
          :items="states"
          v-model="productname"
          >
        </v-select>
      </v-layout>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>notifications</v-icon>
      </v-btn>
      <v-toolbar-side-icon @click.stop="drawerRight = !drawerRight" v-for="user in userInfo" key="userid">
        <img v-if="user.picture" class="picture-profile" :src="user.picture" alt="" width="32" height="32">
        <img v-else class="picture-profile" src="../assets/NoPicture.png" alt=""  width="32" height="32">
      </v-toolbar-side-icon>
    </v-toolbar> -->

    <!-- Mobile & Tablet Toolbar -->
    <!-- <v-toolbar 
      app
      flat
      fixed
      color="grey lighten-5"
      class="hidden-md-and-up" 
      :clipped-right="$vuetify.breakpoint.mdAndUp" 
      :clipped-left="$vuetify.breakpoint.mdAndUp" 
      >
      <v-toolbar-title style="width: 50%" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawerLeft = !drawerLeft"></v-toolbar-side-icon>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="show = !show" v-model="show">
        <v-icon>apps</v-icon>
      </v-btn>
      <v-toolbar-side-icon @click.stop="drawerRight = !drawerRight" v-for="user in userInfo" key="userid">
        <img v-if="user.picture" class="picture-profile" :src="user.picture" alt="" width="32" height="32">
        <img v-else class="picture-profile" src="../assets/NoPicture.png" alt=""  width="32" height="32">
      </v-toolbar-side-icon>
    </v-toolbar> -->

  </div>
</template>

<script>
import UserInfo from '@/components/users/UserInfo'
import Interest from '@/components/dialogs/Interest'
export default {
  name: 'navbar',
  components: {
    'user-info': UserInfo,
    'dialog-interest': Interest
  },
  data() {
    return {
      // Notification
      countNotification: 0,
      // icon group
      iconGroup: false,
      // Products
      products: [],
      show: null,
      onLogin: true,
      drawerMobile: null,
      drawerLeft: null,
      drawerRight: false,
      items: [
        { icon: 'dashboard', title: 'หน้าแรก', link: '/dashboard' },
        // { icon: 'history', title: 'ฤดูกาลผลิต', link: '/seasonal' },
        { icon: 'mdi-corn', title: 'ผลผลิตของคุณ', link: '/productivity' }
      ],
      itemsMarketplace: [
        { icon: 'move_to_inbox', title: 'การเสนอขาย', link: '/purchase' },
        { icon: 'local_grocery_store', title: 'การเสนอซื้อ', link: '/quotation' }
      ],
      itemsGroup: [],
      itemsInterest: [
        {
          icon: 'keyboard_arrow_down',
          'icon-alt': 'keyboard_arrow_down',
          title: 'การติดตาม',
          model: false,
          children: [{ title: '' }, { title: '' }, { title: '' }, { title: '' }, { title: '' }]
        }
      ],
      itemsAdmin: [
        {
          icon: 'keyboard_arrow_down',
          'icon-alt': 'keyboard_arrow_down',
          title: 'Admin',
          model: false,
          children: [
            { title: 'Role', link: '/role' },
            { title: 'Page & Position', link: '/page-position' },
            { title: 'Text & Greeting', link: '/conversation' },
            { title: 'Image & Color', link: '/image-color' },
            { title: 'Match Deal', link: '/match-deal' }  
          ]
        }
      ],
      // User Info
      userInfo: [],
      userInterest: [],
      // Interest
      addInterest: false,
      showInfo: true
    }
  },
  props: {
    source: String
  },
  watch: {
    productname: function() {
      this.onSubmit()
    },
    $route() {
      if (this.$session.get('userid')) {
        this.getNotifications()
      }
      switch (this.$router.history.current.name) {
        case 'Productivity':
          this.showInfo = false

          break
        case 'GroupCreate':
          this.showInfo = false
          break
        case 'MatchDeal':
          this.showInfo = false
          break
        case 'Quotation':
          this.showInfo = false
          break
        case 'Purchase':
          this.showInfo = false
          break
        default:
          this.showInfo = true
          break
      }
    }
  },
  computed: {
    checkLocation() {
      if (this.userInfo[0].province && this.userInfo[0].country) {
        return this.userInfo[0].province + ', ' + this.userInfo[0].country
      } else {
        return 'ไม่ได้ระบุข้อมูล'
      }
    }
  },
  created() {
    this.getUserInfo()
    this.getUserGroup()
    this.getNotifications()
    this.getUserInterest()
  },
  methods: {
    goProductivity() {
      this.$router.push('/productivity')
    },
    getUserInfo() {
      axios
        .get('https://api.farmerspace.co/marketplace/getUserInfo/' + this.$session.get('userid'))
        .then(response => {
          this.userInfo = response.data
          // console.log(response.status); // ex.: 200
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    createGroup() {
      this.$router.push('/group/create')
    },
    getUserGroup() {
      axios
        .get('https://api.farmerspace.co/marketplace/getUserGroup/' + this.$session.get('userid'))
        .then(response => {
          if (response.status == 200) {
            response.data.forEach(element => {
              this.itemsGroup.push({
                groupid: element.groupid,
                title: element.name,
                link: `/group/${element.groupid}`
              })
            })
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    goNotificationPage() {
      this.countNotification = 0
      this.$router.push({ name: 'Notifications' })
    },
    async getNotifications() {
      try {
        this.countNotification = 0
        // Group Notice
        const response_group = await axios.get(
          'https://api.farmerspace.co/marketplace/getGroupNotifications/' +
            this.$session.get('userid')
        )
        if (response_group.data.length > 0) {
          this.countNotification += response_group.data.length
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getUserInterest() {
      try {
        // get user's interest
        const interests = await axios.get(
          'https://api.farmerspace.co/marketplace/getUserInterest/' + this.$session.get('userid')
        )
        // get interest type info
        const types = await axios.get(
          'https://api.farmerspace.co/marketplace/getTypesByOrders/exclude/0'
        )
        // merge type into user's interest
        interests.data.forEach(item => {
          types.data.forEach(element => {
            if (item.typeid == element.typeid) {
              this.userInterest.push({
                typeid: element.typeid,
                nametha: element.nametha,
                nameeng: element.nameeng,
                selected: true
              })
            }
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getTypesByOrders() {
      try {
        this.interests = []
        const types = await axios.get(
          'https://api.farmerspace.co/marketplace/getTypesByOrders/exclude/0'
        )
        types.data.forEach(element => {
          this.interests.push({
            typeid: element.typeid,
            nametha: element.nametha,
            nameeng: element.nameeng,
            selected: false
          })
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chip{
  border:none;
}
.navigation-drawer .list {
  background: transparent;
}
.nav-desktop {
  background: linear-gradient(315deg, #485461 0%, #28313b 74%);
}
.toolbar-desktop {
  background-color: #252525;
}
.logo-img {
  vertical-align: middle;
  width: 120px;
}
.list__tile--active {
  color: #000 !important;
}
.picture-profile {
  object-fit: cover;
  border-radius: 50%;
}
#profile-box {
  position: absolute;
  top: 33px;
  right: 40px;
  width: 350px;
  z-index: 6;
  cursor: pointer;
}
#search-box {
  position: absolute;
  top: 40px;
  left: 20%;
  width: 600px;
  z-index: 4;
  cursor: pointer;
}

#open-left-bar {
  position: absolute;
  top: 40px;
  left: -15px;
  cursor: pointer;
}
.autocomplete__box {
  border-radius: 6px !important;
}
.logo-background {
  background-color: transparent !important;
}
.sub-title {
  font-size: 4px;
  font-weight: 300;
}
.card-points {
  border-radius: 4px;
  background-color: transparent !important;
  & .card-points-count {
    //
  }
  & .card-points-text {
    //
  }
}
.card-products-active {
  cursor: pointer;
  border-radius: 4px;
  background-color: transparent !important;
  // background-image: linear-gradient(to right, #43e97b 0%, #38f9d7 100%);
  & .card-products-active-count {
    color: #fff;
  }
  & .card-products-active-text {
    color: #fff;
  }
}
.btn-close {
  font-size: 16px;
  margin-left: 30px;
  margin-top: -33px;
  cursor: pointer;
}
.card-interest-chip {
  height: 20px;
  font-size: 12px;
  color: #28313b;
  background-image: linear-gradient(to right, #43e97b 0%, #38f9d7 100%) !important;
}
.card-interest-add {
  cursor: pointer;
  font-size: 26px;
  &:hover {
    color: #fff !important;
  }
}
.list__tile__title {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TheNavbar.vue